import * as React from 'react';
import AssetsManager from '../../../../../common/utils/AssetsManager';

class ValidationIdWaitingResponseView extends React.Component<{}, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container text-center">
                            <img className="py-3" src={AssetsManager('/assets/images/common/landing-icon-clock.svg')}/>
                            <h5 className="main-title pt-3">Por favor espere</h5>
                            <p>Se están procesando los datos del cliente para validar su identificación.
                                {'\n'}Ésta operación puede durar algunos minutos.</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ValidationIdWaitingResponseView;
